import { ServerError } from '../errors';
export class APIError extends ServerError {
    path;
    constructor(path, code, serverSideMessage, options) {
        super(`Error occurs when invoking API "${path}": ${serverSideMessage}`, { ...(options ?? {}), code });
        this.path = path;
        this.name = 'bytereplay.core.APIError';
    }
}
